import { Action } from "@ngrx/store";

export abstract class GenericStoreAction implements Action {
    
    public static getItems: string = `get_items`;
    public static getItemsSuccess: string = `get_items_success`;
    public static getItemsError: string = `get_items_error`;

    public static selectItem: string = `select_item`;
    public static selectItemSuccess: string = `select_item_success`;
    public static selectItemError: string = `select_item_error`;

    public static deleteItem: string = `delete_item`;
    public static deleteItemSuccess: string = `delete_item_success`;
    public static deleteItemError: string = `delete_item_error`;

    public static updateItem: string = `update_item`;
    public static updateItemSuccess: string = `update_item_success`;
    public static updateItemError: string = `update_item_error`;

    public static createItem: string = `create_item`;
    public static createItemSuccess: string = `create_item_success`;
    public static createItemError: string = `create_item_error`;

    constructor(
        public type: string,
        public payload?: any){

    }

    matchActionType(actionType: string){
        return !!this.type.match(new RegExp(`${actionType}$`));
    }
}